
import { O37Logo } from "@repo/assets";

export const HeaderMark = ({ maxWidth = "max-w-5xl", logoHeight = "h-[32px]", className }: { maxWidth?: string, logoHeight?: string, className?: string }) => (
  <div className={`pt-10 px-6 sm:px-12 ${className || ''}`}>
    <div className={`${maxWidth} mx-auto flex items-center gap-3`}>
      <img 
        src={O37Logo} 
        alt="o37" 
        className={`${logoHeight} w-auto`}
      />
    </div>
  </div>
);

